type Replacements = { [key: string]: string };

export const endpointReplace = (replacements: Replacements, string: string) =>
  string.replace(/:\w+/g, (all) => replacements[all] || all);
